import { Preloader } from 'mmfintech-portal-commons'

function CustomPreloader() {
  return <Preloader color='black' />
}

export default CustomPreloader
